export { default, getServerSideProps } from './restaurants'
